import { render, staticRenderFns } from "./MessageStorageLink.vue?vue&type=template&id=1952561f&scoped=true"
import script from "./MessageStorageLink.vue?vue&type=script&lang=js"
export * from "./MessageStorageLink.vue?vue&type=script&lang=js"
import style0 from "./MessageStorageLink.vue?vue&type=style&index=0&id=1952561f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1952561f",
  null
  
)

export default component.exports